import "../../global.css";
import React from "react";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const PermissionRequired = () => {
  return (
    <div className={tw`text-center`}>
      <p className={tw`text-base font-semibold text-indigo-600`}>403</p>
      <h1
        className={tw`mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl`}
      >
        Permission Denied
      </h1>
      <p className={tw`mt-6 text-base leading-7 text-gray-600`}>
        Please contact site adminstration for permission
      </p>
    </div>
  );
};

export default PermissionRequired;
